<div class="mb-4 pe-4" elementDataTest="questionsListContainer">
    <!-- List of Questions -->
    <div *ngFor="let question of formArray.controls; let i = index" class="mb-2" [elementDataTest]="'question' + i">
        <!-- Preview View -->
        <app-byoc-episode-step-fetch-questions-question
            *ngIf="i !== editingIndex"
            [formQuestion]="group(question)"
            [index]="i"
        ></app-byoc-episode-step-fetch-questions-question>
        <!-- Edit View -->
        <app-byoc-episode-step-fetch-questions-edit
            *ngIf="i === editingIndex"
            [formQuestion]="group(question)"
            [index]="i"
        ></app-byoc-episode-step-fetch-questions-edit>
    </div>

    <!-- Add new Component -->
    <app-byoc-episode-step-fetch-questions-new *ngIf="creating" [formArray]="formArray"></app-byoc-episode-step-fetch-questions-new>

    <!-- Add new link/button -->
    <div
        role="button"
        tabbable
        *ngIf="!editing"
        (enterKeyUp)="createClick()"
        (click)="createClick()"
        class="link text-info font-semi-bold text-xs pointer"
        buttonDataTest="addNewQuestionButton"
    >
        <span *ngIf="count === 0; else addAnotherQuestionLabel" translate>v3-byoc-popup-create-episode-questions-add-new-question</span>
        <ng-template #addAnotherQuestionLabel>
            <span translate>v3-byoc-popup-create-episode-questions-add-another-question</span>
        </ng-template>
    </div>
</div>
